export enum EventsGenerationMethod {
  STRAIGHT_LINE = 'StraightLine', // Generate the event in a straight line, according to the cycle and period
  FIXED_STRAIGHT_LINE = 'FixedStraightLine', // Same as StraightLine, but the event amount is set by the user
  IMMEDIATE = 'Immediate', // Generate the event per invoice, with identical amount and posting date
}
